import { ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import { Helmet } from 'react-helmet';
import useAuthStore from '../../../store/useAuthStore';
import { getPartnerFaviconUrl, getPartnerName } from '../../../utils/utils';
export interface BaseLayoutProps {
  children?: ReactNode;
}

function BaseLayout(props: BaseLayoutProps) {
  const { children } = props;
  const { partner } = useAuthStore();
  const [faviconUrl, setFaviconUrl] = useState('./favicon.ico');

  useEffect(() => {
    const img = new Image();
    const faviconUrl = getPartnerFaviconUrl(partner);
    img.src = faviconUrl;

    img.onload = () => setFaviconUrl(faviconUrl);
    img.onerror = () => setFaviconUrl('./favicon.ico');
  }, [partner]);

  return (
    <div>
      <Helmet>
        <title>{getPartnerName(partner)}</title>
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href={faviconUrl}
          key="favicon-96"
        />
      </Helmet>
      <Wrapper>
        <Fade
          style={{
            height: '100%',
          }}
          duration={200}
        >
          {children}
        </Fade>
      </Wrapper>
    </div>
  );
}

export default BaseLayout;

const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: var(--app-keyboard-inset-height, 0px);
  overflow: hidden;
  background-color: white;
`;
